













































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalEdit from "@/components/ModalEdit.vue";
import { CMProfile } from "@/models/cm-profile.model";
import { CMProfileSocial } from "@/models/cm-profile-social.model";
import { CMPRofileApi, _retrieveToken } from "@/services/api.service";
import { validationMixin } from "vuelidate";
import {
    required,
    email,
    minLength,
    maxLength
} from "vuelidate/lib/validators";
import myUpload from "vue-image-crop-upload";

@Component({
    components: {
        ModalEdit,
        myUpload
    },
    mixins: [validationMixin],
    validations: {
        formName: {
            required
        },
        formSurname: {
            required
        }
    }
})
export default class ProfileBasic extends Vue {
    @Prop({ type: Boolean, default: false })
    public authorRequire;

    public get isFromAppMobile(): boolean {
        return this.$store.getters.isFromAppMobile;
    }

    public showEditDialog: boolean = false;
    public saving: boolean = false;

    public imgDefault = {
        backgroundImage: "url(/img/default-user.png)"
    };
    public imgDataUrl: string = "";
    public show: boolean = false;
    public params = {
        token: "12345667",
        name: "avatar"
    };
    public headers = {
        smail: "*_~",
        Authorization: "Bearer " + _retrieveToken()
    };

    public get profileSocials() {
        return this.profile.socials.filter(el => el.link);
    }

    public formName: string = "";
    public formSurname: string = "";
    public formHeadline: string = "";

    public fbSocial = {
        name: "Facebook",
        _type: "CMProfileSocialFB",
        link: ""
    };

    public twSocial = {
        name: "Twitter",
        _type: "CMProfileSocialTW",
        link: ""
    };

    public ghSocial = {
        name: "GitHub",
        _type: "CMProfileSocialGH",
        link: ""
    };

    public lnSocial = {
        name: "Linkedin",
        _type: "CMProfileSocialLN",
        link: ""
    };

    public get profile() {
        return this.$store.getters.profile;
    }

    public mounted() {
        this.__mapDataToForm();
    }

    public handleModalClose() {
        this.showEditDialog = false;
    }

    public openModalEdit() {
        this.showEditDialog = true;
    }

    public getSocialClass(social: CMProfileSocial): string {
        switch (social.type) {
            case "CMProfileSocialFB":
                return "mdi-facebook";
            case "CMProfileSocialTW":
                return "mdi-twitter";
            case "CMProfileSocialGH":
                return "mdi-github-circle";
            case "CMProfileSocialLN":
                return "mdi-linkedin";
            default:
                return "mdi-web";
        }
    }

    public getSocialLink(type: string): string {
        if (!this.profile || !this.profile.socials) {
            return "";
        }
        const social = this.profile.socials.find(s => {
            return s.type === type;
        });
        if (!social) {
            return "";
        }
        return social.link;
    }

    public getSocial(type: string): CMProfileSocial {
        if (!this.profile || !this.profile.socials) {
            return new CMProfileSocial();
        }
        const social = this.profile.socials.find(s => {
            return s.type === type;
        });
        if (!social) {
            return new CMProfileSocial();
        }
        return social;
    }

    public goToCheckin() {
        window.open(this.$store.getters.conf.checkin_url, "blank");
    }

    public async updateProfile() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.saving = true;
        this.__mapFormToProfile();
        try {
            await CMPRofileApi.updateBasic({
                name: this.profile.name,
                surname: this.profile.surname,
                headline: this.profile.headline,
                socials: this.profile.socials
            });
            this.$store.commit("updateProfile", this.profile);
            this.showEditDialog = false;
            this.saving = false;
        } catch (e) {
            this.saving = false;
            console.error(e);
        }
    }

    @Watch("profile", { deep: true })
    public onProfileChange(val: CMProfile, oldVal: CMProfile) {
        this.__mapDataToForm();
    }

    public getValidationClass(fieldName, forceInvalid = false) {
        const field = this.$v[fieldName];
        if (field) {
            return {
                "md-invalid": (field.$invalid && field.$dirty) || forceInvalid
            };
        }
    }

    public toggleShow() {
        this.show = !this.show;
    }

    public cropUploadSuccess(jsonData, field) {
        this.profile.photo = jsonData.data;
        this.imgDataUrl = this.profile.photo + "?v=" + Date.now();
        this.$store.commit("updateProfile", this.profile);
    }

    private __mapDataToForm() {
        if (this.profile) {
            this.formName = this.profile.name;
            this.formSurname = this.profile.surname;
            this.formHeadline = this.profile.headline;
            this.imgDataUrl = this.profile.photo;
            this.fbSocial.link = this.getSocialLink(this.fbSocial._type);
            this.twSocial.link = this.getSocialLink(this.twSocial._type);
            this.lnSocial.link = this.getSocialLink(this.lnSocial._type);
            this.ghSocial.link = this.getSocialLink(this.ghSocial._type);
        }
    }

    private __mapFormToProfile() {
        this.profile.name = this.formName;
        this.profile.surname = this.formSurname;
        this.profile.headline = this.formHeadline;
        this.profile.addSocial(new CMProfileSocial().fromRaw(this.fbSocial));
        this.profile.addSocial(new CMProfileSocial().fromRaw(this.twSocial));
        this.profile.addSocial(new CMProfileSocial().fromRaw(this.ghSocial));
        this.profile.addSocial(new CMProfileSocial().fromRaw(this.lnSocial));
    }
}
